module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pb-10",
    attrs: {
      "id": "itembank-form"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'Bank Soal',
          to: {
            path: '/items',
            query: {
              mapel: _vm.$route.query.mapel
            },
          },
          exact: true,
        },
        {
          text: !_vm.$route.query.id ? 'Tambah Soal Baru' : 'Ubah Soal'
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("\n        " + _vm._s(!_vm.$route.query.id ? "Tambah Soal Baru" : "Ubah Soal") + "\n    ")]), _vm._v(" "), _c('v-card', [(_vm.$route.query.id) ? _c('v-card-title', [_vm._v("Edit Soal")]) : _vm._e(), _vm._v(" "), (!_vm.$route.query.id) ? _c('v-card-title', [_vm._v("Tambah Soal")]) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-list-item', {
    staticClass: "px-0 pt-0 pb-4",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                        Mata Pelajaran *\n                    ")]), _vm._v(" "), _c('v-select', {
    staticClass: "pa-0",
    attrs: {
      "placeholder": "Pilih Mata Pelajaran",
      "outlined": "",
      "items": _vm.mapelList,
      "item-text": "nama",
      "item-value": "id"
    },
    on: {
      "change": _vm.onMapelChanged
    },
    model: {
      value: (_vm.form.mapel),
      callback: function($$v) {
        _vm.$set(_vm.form, "mapel", $$v)
      },
      expression: "form.mapel"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                        Jenjang *\n                    ")]), _vm._v(" "), _c('v-radio-group', {
    staticClass: "ma-0",
    attrs: {
      "row": ""
    },
    on: {
      "change": function($event) {
        return _vm.resetGrades()
      }
    },
    model: {
      value: (_vm.form.jenjang),
      callback: function($$v) {
        _vm.$set(_vm.form, "jenjang", $$v)
      },
      expression: "form.jenjang"
    }
  }, _vm._l((_vm.levels), function(level) {
    return _c('v-radio', {
      key: level.id,
      staticClass: "jenjang-selection",
      attrs: {
        "value": level.id,
        "label": level.nama,
        "active-class": "act-radio-btn"
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                        Kelas *\n                    ")]), _vm._v(" "), (_vm.form.jenjang === 1) ? _c('div', {
    staticClass: "d-inline"
  }, [_c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "label": "4",
      "value": 4,
      "outlined": ""
    },
    model: {
      value: (_vm.grades),
      callback: function($$v) {
        _vm.grades = $$v
      },
      expression: "grades"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "label": "5",
      "value": 5,
      "outlined": ""
    },
    model: {
      value: (_vm.grades),
      callback: function($$v) {
        _vm.grades = $$v
      },
      expression: "grades"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "label": "6",
      "value": 6,
      "outlined": ""
    },
    model: {
      value: (_vm.grades),
      callback: function($$v) {
        _vm.grades = $$v
      },
      expression: "grades"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.form.jenjang === 2) ? _c('div', {
    staticClass: "d-inline"
  }, [_c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "label": "7",
      "value": 7,
      "outlined": ""
    },
    model: {
      value: (_vm.grades),
      callback: function($$v) {
        _vm.grades = $$v
      },
      expression: "grades"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "label": "8",
      "value": 8,
      "outlined": ""
    },
    model: {
      value: (_vm.grades),
      callback: function($$v) {
        _vm.grades = $$v
      },
      expression: "grades"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "label": "9",
      "value": 9,
      "outlined": ""
    },
    model: {
      value: (_vm.grades),
      callback: function($$v) {
        _vm.grades = $$v
      },
      expression: "grades"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.form.jenjang === 3) ? _c('div', {
    staticClass: "d-inline"
  }, [_c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "label": "10",
      "value": 10,
      "outlined": ""
    },
    model: {
      value: (_vm.grades),
      callback: function($$v) {
        _vm.grades = $$v
      },
      expression: "grades"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "label": "11",
      "value": 11,
      "outlined": ""
    },
    model: {
      value: (_vm.grades),
      callback: function($$v) {
        _vm.grades = $$v
      },
      expression: "grades"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "label": "12",
      "value": 12,
      "outlined": ""
    },
    model: {
      value: (_vm.grades),
      callback: function($$v) {
        _vm.grades = $$v
      },
      expression: "grades"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "px-0 pt-0 pb-4",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                        Jenis *\n                    ")]), _vm._v(" "), _c('v-select', {
    staticClass: "pa-0",
    attrs: {
      "placeholder": "Pilih Jenis",
      "outlined": "",
      "items": _vm.types,
      "item-text": "nama",
      "item-value": "id"
    },
    model: {
      value: (_vm.form.jenis),
      callback: function($$v) {
        _vm.$set(_vm.form, "jenis", $$v)
      },
      expression: "form.jenis"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                        Topik *\n                    ")]), _vm._v(" "), _c('app-autocomplete', {
    attrs: {
      "placeholder": "Cari Bab / (Sub) Sub Bab",
      "data": _vm.topics,
      "value": _vm.form.topic,
      "topic": _vm.form.subSubBabId ?
        _vm.form.subSubBabId :
        _vm.form.subBabId ?
        _vm.form.subBabId :
        _vm.form.babId
    },
    on: {
      "selected": function($event) {
        return _vm.assignTopic($event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                        Label\n                    ")]), _vm._v(" "), _c('v-combobox', {
    attrs: {
      "placeholder": "Catatan soal",
      "items": _vm.labels,
      "search-input": _vm.form.label,
      "outlined": "",
      "maxlength": "255"
    },
    on: {
      "keyup": function($event) {
        _vm.form.label = _vm.form.label.toUpperCase()
      },
      "update:searchInput": function($event) {
        return _vm.$set(_vm.form, "label", $event)
      },
      "update:search-input": function($event) {
        return _vm.$set(_vm.form, "label", $event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                        Sumber\n                    ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Sumber",
      "outlined": ""
    },
    model: {
      value: (_vm.form.sumber),
      callback: function($$v) {
        _vm.$set(_vm.form, "sumber", $$v)
      },
      expression: "form.sumber"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                        Bank Soal\n                    ")]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "label": "Tidak dimunculkan",
      "outlined": ""
    },
    model: {
      value: (_vm.form.is_restricted),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_restricted", $$v)
      },
      expression: "form.is_restricted"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pt-2"
  }, [_vm._v("\n                        Tingkat Kesulitan *\n                    ")]), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.form.difficulty_level),
      callback: function($$v) {
        _vm.$set(_vm.form, "difficulty_level", $$v)
      },
      expression: "form.difficulty_level"
    }
  }, [_c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "id": "difficulty_level_lots",
      "label": "LOTS",
      "value": "LOTS",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "id": "difficulty_level_mots",
      "label": "MOTS",
      "value": "MOTS",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "id": "difficulty_level_hots",
      "label": "HOTS",
      "value": "HOTS",
      "active-class": "act-radio-btn"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pt-5"
  }, [_vm._v("\n                        Tipe Pilihan *\n                    ")]), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.form.selection_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "selection_type", $$v)
      },
      expression: "form.selection_type"
    }
  }, [_c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "id": "selection_type_single",
      "label": "Tunggal",
      "value": "single",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "id": "selection_type_multiple",
      "label": "Banyak",
      "value": "multiple",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "id": "selection_type_choice",
      "label": "Benar/Salah",
      "value": "truefalse",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "id": "selection_type_inputtext",
      "label": "Isian Singkat",
      "value": "inputtext",
      "active-class": "act-radio-btn"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                        Wacana\n                    ")]), _vm._v(" "), _c('app-wacana', {
    ref: "wacanaComp",
    attrs: {
      "mapel": _vm.form.mapel,
      "value": _vm.form.wacana
    },
    on: {
      "selected": function($event) {
        _vm.form.wacana = $event
      }
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.form.selection_type != 'inputtext') ? _c('v-card', {
    staticClass: "pa-0 my-4",
    attrs: {
      "plain": ""
    }
  }, [_c('v-card-title', {
    staticClass: "text-subtitle-1 font-weight-bold"
  }, [_vm._v("\n            Soal & Jawaban *\n            "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "darkGreen--text",
    attrs: {
      "disabled": _vm.form.opsiA == '' || _vm.form.opsiB == '' || _vm.form.soal == '',
      "color": "backgroundGreen",
      "elevation": "0"
    },
    on: {
      "click": function($event) {
        return _vm.getPreview()
      }
    }
  }, [_vm._v("\n                Preview\n            ")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "color": "#f0f3f9"
    }
  }, [_c('v-card-text', {
    staticClass: "font-weight-600 mb-5 align-center d-flex",
    staticStyle: {
      "color": "#0e97d6"
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("\n                            mdi-information\n                        ")]), _vm._v("\n\n                        Jumlah pilihan jawaban menyesuaikan dengan value\n                        jawaban yang diisi\n                    ")], 1)], 1), _vm._v(" "), _c('app-editor', {
    attrs: {
      "value": _vm.form.soal,
      "context": _vm.mapel,
      "hasUpload": true,
      "title": "Soal *"
    },
    on: {
      "content-updated": function($event) {
        _vm.form.soal = $event
      },
      "preview": function($event) {
        return _vm.showModalAppEditor($event)
      }
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('v-card', {
    staticClass: "d-flex",
    class: {
      'has-error': _vm.errors.indexOf('opsiA') >= 0,
    },
    attrs: {
      "plain": "",
      "color": "#ECEFF5"
    }
  }, [_c('div', {
    staticClass: "px-4 py-3 d-flex align-center justify-center black60--text",
    attrs: {
      "cols": "1"
    }
  }, [_c('span', {
    staticClass: "text-subtitle-2 font-weight-bold"
  }, [_vm._v("A")])]), _vm._v(" "), _c('app-editor', {
    staticClass: "pa-0 ma-0 flex-grow-1",
    attrs: {
      "value": _vm.form.opsiA,
      "answer": _vm.form.answerA,
      "context": _vm.mapel,
      "hasUpload": true,
      "title": "Jawaban *",
      "type": "jawaban"
    },
    on: {
      "content-updated": function($event) {
        _vm.form.opsiA = $event
      },
      "status-updated": function($event) {
        _vm.form.answerA = $event
      },
      "preview": function($event) {
        return _vm.showModalAppEditor($event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('v-card', {
    staticClass: "d-flex",
    class: {
      'has-error': _vm.errors.indexOf('opsiB') >= 0,
    },
    attrs: {
      "plain": "",
      "color": "#ECEFF5"
    }
  }, [_c('div', {
    staticClass: "px-4 py-3 d-flex align-center justify-center black60--text",
    attrs: {
      "cols": "1"
    }
  }, [_c('span', {
    staticClass: "text-subtitle-2 font-weight-bold"
  }, [_vm._v("B")])]), _vm._v(" "), _c('app-editor', {
    staticClass: "pa-0 ma-0 flex-grow-1",
    attrs: {
      "value": _vm.form.opsiB,
      "context": _vm.mapel,
      "hasUpload": true,
      "answer": _vm.form.answerB,
      "title": "Jawaban *",
      "type": "jawaban"
    },
    on: {
      "content-updated": function($event) {
        _vm.form.opsiB = $event
      },
      "status-updated": function($event) {
        _vm.form.answerB = $event
      },
      "preview": function($event) {
        return _vm.showModalAppEditor($event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('v-card', {
    staticClass: "d-flex",
    class: {
      'has-error': _vm.errors.indexOf('opsiC') >= 0,
    },
    attrs: {
      "plain": "",
      "color": "#ECEFF5"
    }
  }, [_c('div', {
    staticClass: "px-4 py-3 d-flex align-center justify-center black60--text",
    attrs: {
      "cols": "1"
    }
  }, [_c('span', {
    staticClass: "text-subtitle-2 font-weight-bold"
  }, [_vm._v("C")])]), _vm._v(" "), _c('app-editor', {
    staticClass: "pa-0 ma-0 flex-grow-1",
    attrs: {
      "value": _vm.form.opsiC,
      "answer": _vm.form.answerC,
      "context": _vm.mapel,
      "hasUpload": true,
      "title": "Jawaban",
      "type": "jawaban"
    },
    on: {
      "content-updated": function($event) {
        _vm.form.opsiC = $event
      },
      "status-updated": function($event) {
        _vm.form.answerC = $event
      },
      "preview": function($event) {
        return _vm.showModalAppEditor($event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('v-card', {
    staticClass: "d-flex",
    class: {
      'has-error': _vm.errors.indexOf('opsiD') >= 0,
    },
    attrs: {
      "plain": "",
      "color": "#ECEFF5"
    }
  }, [_c('div', {
    staticClass: "px-4 py-3 d-flex align-center justify-center black60--text",
    attrs: {
      "cols": "1"
    }
  }, [_c('span', {
    staticClass: "text-subtitle-2 font-weight-bold"
  }, [_vm._v("D")])]), _vm._v(" "), _c('app-editor', {
    staticClass: "pa-0 ma-0 flex-grow-1",
    attrs: {
      "value": _vm.form.opsiD,
      "context": _vm.mapel,
      "hasUpload": true,
      "answer": _vm.form.answerD,
      "title": "Jawaban",
      "type": "jawaban"
    },
    on: {
      "content-updated": function($event) {
        _vm.form.opsiD = $event
      },
      "status-updated": function($event) {
        _vm.form.answerD = $event
      },
      "preview": function($event) {
        return _vm.showModalAppEditor($event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('span', [_vm._v("Opsional")]), _vm._v(" "), _c('v-card', {
    staticClass: "d-flex mt-3",
    attrs: {
      "plain": "",
      "color": "#ECEFF5"
    }
  }, [_c('div', {
    staticClass: "px-4 py-3 d-flex align-center justify-center black60--text",
    attrs: {
      "cols": "1"
    }
  }, [_c('span', {
    staticClass: "text-subtitle-2 font-weight-bold"
  }, [_vm._v("E")])]), _vm._v(" "), _c('app-editor', {
    staticClass: "pa-0 ma-0 flex-grow-1",
    attrs: {
      "value": _vm.form.opsiE,
      "context": _vm.mapel,
      "hasUpload": true,
      "answer": _vm.form.answerE,
      "title": "Jawaban",
      "type": "jawaban"
    },
    on: {
      "content-updated": function($event) {
        _vm.form.opsiE = $event
      },
      "status-updated": function($event) {
        _vm.form.answerE = $event
      },
      "preview": function($event) {
        return _vm.showModalAppEditor($event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('app-editor', {
    attrs: {
      "value": _vm.form.pembahasan,
      "context": _vm.mapel,
      "hasUpload": true,
      "title": "Pembahasan"
    },
    on: {
      "content-updated": function($event) {
        _vm.form.pembahasan = $event
      },
      "preview": function($event) {
        return _vm.showModalAppEditor($event)
      }
    }
  })], 1), _vm._v(" "), _c('v-col', {
    class: {
      'has-error': _vm.errors.indexOf('jawaban') >= 0,
    },
    attrs: {
      "cols": "8"
    }
  }, [_c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                            Jawaban *\n                        ")]), _vm._v(" "), _c('v-radio-group', {
    staticClass: "ma-0",
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.form.jawaban),
      callback: function($$v) {
        _vm.$set(_vm.form, "jawaban", $$v)
      },
      expression: "form.jawaban"
    }
  }, [_c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "value": "A",
      "label": "A",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "value": "B",
      "label": "B",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "value": "C",
      "label": "C",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "value": "D",
      "label": "D",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "value": "E",
      "label": "E",
      "active-class": "act-radio-btn"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                            Eigen\n                        ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "2.55",
      "type": "number",
      "step": "any",
      "outlined": ""
    },
    model: {
      value: (_vm.form.eigen),
      callback: function($$v) {
        _vm.$set(_vm.form, "eigen", $$v)
      },
      expression: "form.eigen"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pt-0 px-0 pb-6"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                        User Group\n                    ")]), _vm._v(" "), _vm._l((_vm.form.user_group), function(usgr, i) {
    return _c('v-autocomplete', {
      key: i,
      staticClass: "pb-2",
      attrs: {
        "items": _vm.user_groups,
        "item-text": "user_group_name",
        "item-value": "id",
        "placeholder": "-- Pilih user group --",
        "outlined": ""
      },
      scopedSlots: _vm._u([{
        key: "append-outer",
        fn: function() {
          return [(
            i === _vm.form.user_group.length - 1 &&
            _vm.form.user_group.length != 1
          ) ? _c('v-btn', {
            staticClass: "font-weight-bold dark--text py-3",
            attrs: {
              "id": "user-remove-scope-btn",
              "dark": "",
              "x-large": "",
              "depressed": "",
              "color": "white",
              "elevation": "1"
            },
            on: {
              "click": function($event) {
                _vm.queryId
                  ?
                  null :
                  _vm.form.user_group.splice(i, 1)
              }
            }
          }, [_vm._v("\n                                Hapus\n                            ")]) : _vm._e()]
        },
        proxy: true
      }], null, true),
      model: {
        value: (_vm.form.user_group[i]),
        callback: function($$v) {
          _vm.$set(_vm.form.user_group, i, $$v)
        },
        expression: "form.user_group[i]"
      }
    })
  })], 2)], 1), _vm._v(" "), _c('v-container', [_c('v-btn', {
    staticClass: "font-weight-bold blew--text mb-5",
    attrs: {
      "id": "user-add-scope-btn",
      "block": "",
      "depressed": "",
      "color": "#e8f5fa"
    },
    on: {
      "click": function($event) {
        return _vm.form.user_group.push('')
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    staticStyle: {
      "font-size": "16px !important"
    }
  }, [_vm._v("\n                        mdi-plus-circle\n                    ")]), _vm._v("\n                    Tambah User Group Baru\n                ")], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.selection_type === 'inputtext') ? _c('v-card', {
    staticClass: "pa-0 my-4",
    attrs: {
      "plain": ""
    }
  }, [_c('v-card-title', {
    staticClass: "text-subtitle-1 font-weight-bold"
  }, [_vm._v("\n            Soal & Jawaban *\n            "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "darkGreen--text",
    attrs: {
      "disabled": _vm.form.jawaban == '' || _vm.form.soal == '',
      "color": "backgroundGreen",
      "elevation": "0"
    },
    on: {
      "click": function($event) {
        return _vm.getPreview()
      }
    }
  }, [_vm._v("\n                Preview\n            ")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('app-editor', {
    attrs: {
      "value": _vm.form.soal,
      "context": _vm.mapel,
      "hasUpload": true,
      "title": "Soal *"
    },
    on: {
      "content-updated": function($event) {
        _vm.form.soal = $event
      },
      "preview": function($event) {
        return _vm.showModalAppEditor($event)
      }
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('input', {
    staticClass: "form-control input-lg",
    attrs: {
      "type": "text",
      "disabled": "",
      "placeholder": "Isian Jawaban"
    }
  })]), _vm._v(" "), (_vm.showTambahKalimat === true && _vm.form.soalTambah === '') ? _c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('v-btn', {
    staticClass: "font-weight-bold dark--text",
    attrs: {
      "id": "user-add-scope-btn",
      "block": "",
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.showTambahKalimatButton()
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "font-size": "16px !important"
    }
  }, [_vm._v("mdi-plus-circle")]), _vm._v("\n                    Tambah Kalimat\n                ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.addSoal === true || _vm.form.soalTambah != '') ? _c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('app-editor', {
    attrs: {
      "value": _vm.form.soalTambah,
      "context": _vm.mapel,
      "hasUpload": true,
      "title": "Soal"
    },
    on: {
      "content-updated": function($event) {
        _vm.form.soalTambah = $event
      },
      "preview": function($event) {
        return _vm.showModalAppEditor($event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('app-editor', {
    attrs: {
      "value": _vm.form.pembahasan,
      "context": _vm.mapel,
      "hasUpload": true,
      "title": "Pembahasan"
    },
    on: {
      "content-updated": function($event) {
        _vm.form.pembahasan = $event
      },
      "preview": function($event) {
        return _vm.showModalAppEditor($event)
      }
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                            Jawaban *\n                        ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Jawaban",
      "outlined": ""
    },
    model: {
      value: (_vm.form.jawaban),
      callback: function($$v) {
        _vm.$set(_vm.form, "jawaban", $$v)
      },
      expression: "form.jawaban"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                            Eigen\n                        ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "2.55",
      "type": "number",
      "step": "any",
      "outlined": ""
    },
    model: {
      value: (_vm.form.eigen),
      callback: function($$v) {
        _vm.$set(_vm.form, "eigen", $$v)
      },
      expression: "form.eigen"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pt-0 px-0 pb-6"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                        User Group\n                    ")]), _vm._v(" "), _vm._l((_vm.form.user_group), function(usgr, i) {
    return _c('v-autocomplete', {
      key: i,
      staticClass: "pb-2",
      attrs: {
        "items": _vm.user_groups,
        "item-text": "user_group_name",
        "item-value": "id",
        "placeholder": "-- Pilih user group --",
        "outlined": ""
      },
      scopedSlots: _vm._u([{
        key: "append-outer",
        fn: function() {
          return [(
            i === _vm.form.user_group.length - 1 &&
            _vm.form.user_group.length != 1
          ) ? _c('v-btn', {
            staticClass: "font-weight-bold dark--text py-3",
            attrs: {
              "id": "user-remove-scope-btn",
              "dark": "",
              "x-large": "",
              "depressed": "",
              "color": "white",
              "elevation": "1"
            },
            on: {
              "click": function($event) {
                _vm.queryId
                  ?
                  null :
                  _vm.form.user_group.splice(i, 1)
              }
            }
          }, [_vm._v("\n                                Hapus\n                            ")]) : _vm._e()]
        },
        proxy: true
      }], null, true),
      model: {
        value: (_vm.form.user_group[i]),
        callback: function($$v) {
          _vm.$set(_vm.form.user_group, i, $$v)
        },
        expression: "form.user_group[i]"
      }
    })
  })], 2)], 1), _vm._v(" "), _c('v-container', [_c('v-btn', {
    staticClass: "font-weight-bold blew--text mb-5",
    attrs: {
      "id": "user-add-scope-btn",
      "block": "",
      "depressed": "",
      "color": "#e8f5fa"
    },
    on: {
      "click": function($event) {
        return _vm.form.user_group.push('')
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    staticStyle: {
      "font-size": "16px !important"
    }
  }, [_vm._v("\n                        mdi-plus-circle\n                    ")]), _vm._v("\n                    Tambah User Group Baru\n                ")], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-row', {
    staticClass: "pa-4"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "large": "",
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.saveItembank()
      }
    }
  }, [_vm._v("\n            Simpan\n        ")])], 1), _vm._v(" "), (_vm.showModal) ? _c('v-dialog', {
    attrs: {
      "transition": "dialog-top-transition",
      "width": "360px",
      "min-height": "537px",
      "max-height": "771px",
      "scrollable": ""
    },
    on: {
      "click:outside": function($event) {
        _vm.showModal = false
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(dialog) {
        return [_c('v-card', [_c('v-card-title', {
          staticClass: "d-flex",
          attrs: {
            "width": "100%"
          }
        }, [_vm._v("\n                    Preview Soal\n                    "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
          attrs: {
            "icon": "",
            "small": ""
          },
          on: {
            "click": function($event) {
              dialog.value = false
            }
          }
        }, [_c('v-icon', [_vm._v("mdi-close-circle")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
          staticClass: "pa-0",
          attrs: {
            "width": "100%"
          }
        }, [_c('v-card', {
          staticClass: "py-2",
          attrs: {
            "flat": "",
            "color": "#f3f5f7"
          }
        }, [(_vm.preview.wacana) ? _c('v-card', {
          staticClass: "ma-0 mb-2",
          attrs: {
            "flat": ""
          }
        }, [_c('v-list-item', {
          attrs: {
            "two-line": ""
          }
        }, [_c('v-list-item-content', [_c('v-list-item-title', {
          staticClass: "text-body-2 black--text"
        }, [(!!_vm.form.wacana) ? _c('p', {
          staticStyle: {
            "white-space": "pre-line"
          },
          domProps: {
            "innerHTML": _vm._s(_vm.previewWacana)
          }
        }) : _vm._e()])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-card', {
          staticClass: "mx-0 mb-2",
          attrs: {
            "flat": ""
          }
        }, [_c('v-list-item', {
          attrs: {
            "two-line": ""
          }
        }, [_c('v-list-item-content', [_c('v-list-item-title', {
          staticClass: "text-body-2 black--text"
        }, [_c('div', {
          staticStyle: {
            "white-space": "pre-line"
          },
          domProps: {
            "innerHTML": _vm._s(
              _vm.parseLatex(_vm.preview.soal)
            )
          }
        })])], 1)], 1)], 1), _vm._v(" "), (_vm.form.selection_type != 'inputtext') ? _c('v-card', {
          staticClass: "mx-0 my-2",
          attrs: {
            "flat": ""
          }
        }, [_c('v-list', [_c('v-list-item', {
          staticStyle: {
            "min-height": "none !important"
          },
          attrs: {
            "two-line": ""
          }
        }, [_c('v-list-item-content', [_c('v-list-item-title', {
          staticClass: "font-weight-bold black--text pa-0"
        }, [_vm._v("\n                                            Pilihan Jawaban\n                                        ")])], 1)], 1), _vm._v(" "), _vm._l((_vm.preview.pilihan), function(jawaban, i) {
          return (
            _vm.form.selection_type === 'single' ||
            _vm.form.selection_type === 'multiple'
          ) ? _c('v-card', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (jawaban.value),
              expression: "jawaban.value"
            }],
            key: i,
            staticClass: "mx-4 my-2",
            attrs: {
              "elevation": "0",
              "color": "#ECEFF5"
            }
          }, [_c('div', {
            staticClass: "pa-2 d-flex align-center",
            class: jawaban.answer === true ?
              'bg-success text-white' :
              'black60--text',
            attrs: {
              "cols": "1"
            }
          }, [_c('span', {
            staticClass: "text-subtitle-1 font-weight-bold px-2"
          }, [_vm._v("\n                                            " + _vm._s(jawaban.key) + "\n                                        ")]), _vm._v(" "), _c('div', {
            domProps: {
              "innerHTML": _vm._s(
                _vm.parseLatex(jawaban.value)
              )
            }
          })])]) : _vm._e()
        }), _vm._v(" "), (
          _vm.form.selection_type === 'truefalse'
        ) ? _c('div', {
          staticClass: "mx-4 my-2 mb-4"
        }, [_c('table', {
          attrs: {
            "width": "100%",
            "cellpadding": "10"
          }
        }, [_c('tr', {
          staticStyle: {
            "background-color": "#f3f5f7"
          }
        }, [_c('td', {
          staticClass: "pa-3",
          attrs: {
            "width": "60%"
          }
        }, [_vm._v("\n                                                Pernyataan\n                                            ")]), _vm._v(" "), _c('td', {
          staticClass: "pa-3",
          attrs: {
            "align": "center"
          }
        }, [_vm._v("\n                                                Benar\n                                            ")]), _vm._v(" "), _c('td', {
          staticClass: "pa-3",
          attrs: {
            "align": "center"
          }
        }, [_vm._v("\n                                                Salah\n                                            ")])]), _vm._v(" "), _vm._l((_vm.preview.pilihan), function(jawaban, i) {
          return _c('tr', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (jawaban.value),
              expression: "jawaban.value"
            }],
            staticStyle: {
              "border-top": "1px solid"
            }
          }, [_c('td', {
            staticClass: "pa-3",
            attrs: {
              "width": "40%"
            }
          }, [_c('div', {
            domProps: {
              "innerHTML": _vm._s(
                _vm.parseLatex(
                  jawaban.value
                )
              )
            }
          })]), _vm._v(" "), _c('td', {
            staticClass: "pa-3 text-center",
            class: jawaban.answer === true ?
              'bg-success text-white' :
              'bg-error'
          }, [(jawaban.answer) ? _c('v-icon', {
            staticStyle: {
              "font-size": "20px"
            },
            attrs: {
              "color": "white"
            }
          }, [_vm._v("\n                                                    mdi-check-circle\n                                                ")]) : _vm._e()], 1), _vm._v(" "), _c('td', {
            staticClass: "pa-3 text-center",
            class: !jawaban.answer ?
              'bg-success text-white' :
              'bg-error'
          }, [(!jawaban.answer) ? _c('v-icon', {
            staticStyle: {
              "font-size": "20px"
            },
            attrs: {
              "color": "white"
            }
          }, [_vm._v("\n                                                    mdi-check-circle\n                                                ")]) : _vm._e()], 1)])
        })], 2)]) : _vm._e()], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.form.selection_type === 'inputtext') ? _c('v-card', {
          staticClass: "mx-0 my-2",
          attrs: {
            "flat": ""
          }
        }, [_c('v-list', [_c('v-list-item', {
          staticStyle: {
            "min-height": "none !important"
          },
          attrs: {
            "two-line": ""
          }
        }, [_c('v-list-item-content', [_c('v-list-item-subtitle', {
          staticClass: "font-weight-bold black--text pa-0"
        }, [_vm._v("\n                                            Jawaban\n                                        ")]), _vm._v(" "), _c('div', {
          domProps: {
            "innerHTML": _vm._s(_vm.parseLatex(_vm.preview.key))
          }
        })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-card', {
          staticClass: "mx-0 my-2",
          attrs: {
            "flat": ""
          }
        }, [_c('v-list', [_c('v-list-item', {
          staticStyle: {
            "min-height": "none !important"
          },
          attrs: {
            "two-line": ""
          }
        }, [_c('v-list-item-content', [_c('v-list-item-subtitle', {
          staticClass: "font-weight-bold black--text pa-0"
        }, [_vm._v("\n                                            Pembahasan\n                                        ")]), _vm._v(" "), _c('v-list-item-title', {
          staticClass: "text-body-2 black--text",
          domProps: {
            "innerHTML": _vm._s(
              _vm.parseLatex(
                _vm.preview.explanation
              )
            )
          }
        })], 1)], 1)], 1)], 1)], 1)], 1)], 1)]
      }
    }], null, false, 1139272905),
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "520",
      "scrollable": ""
    },
    on: {
      "click:outside": function($event) {
        _vm.showModalEditor = false
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(dialog) {
        return [_c('v-card', [_c('v-card-title', [_vm._v("Preview " + _vm._s(_vm.title))]), _vm._v(" "), _c('v-card-text', {
          staticClass: "py-5",
          attrs: {
            "width": "100%"
          },
          domProps: {
            "innerHTML": _vm._s(_vm.parseLatex(_vm.app_editor_val))
          }
        }), _vm._v(" "), _c('v-card-actions', {
          staticClass: "justify-end"
        }, [_c('v-btn', {
          attrs: {
            "dark": "",
            "color": "blew",
            "elevation": "0"
          },
          on: {
            "click": function($event) {
              dialog.value = false
            }
          }
        }, [_vm._v("Tutup")])], 1)], 1)]
      }
    }]),
    model: {
      value: (_vm.showModalEditor),
      callback: function($$v) {
        _vm.showModalEditor = $$v
      },
      expression: "showModalEditor"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04662d4f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/itembank/components/Form.vue
// module id = 1552
// module chunks = 1